import { Button } from "@/components/ui/button";
import { Clock } from "lucide-react";

interface Props {
  onFinish: () => void;
  onTryAgain: () => void;
}

export default function DelayEndingScreen({ onFinish, onTryAgain }: Props) {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="glass-card glow-border max-w-md w-full p-8 text-center space-y-6">
        <div className="w-16 h-16 rounded-2xl bg-accent/10 flex items-center justify-center mx-auto">
          <Clock className="w-8 h-8 text-accent" />
        </div>
        <h2 className="font-heading text-xl font-bold text-foreground">Waiting Can Be a Strong Financial Choice</h2>
        <p className="text-sm text-muted-foreground leading-relaxed">
          Choosing to delay a home purchase is not failure. Sometimes saving more, reducing future risk,
          or waiting for a more affordable option is the smartest move.
        </p>
        <div className="flex flex-col gap-3">
          <Button onClick={onFinish} className="w-full">Finish Module</Button>
          <Button variant="outline" onClick={onTryAgain} className="w-full">Try Again</Button>
        </div>
      </div>
    </div>
  );
}
